import './footer.styles.scss';

const Footer = () => {
    return (
        <footer></footer>
    )
}

export default Footer;